module.exports = __webpack_public_path__ + "static/media/briefOne.bef7bf8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/briefOne.jpg
// module id = 1735
// module chunks = 0 1